import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { confirmAlert, errorAlert } from "../../../helpers/alerts";
import { BackButton, BagOperationForm } from "../../../components";
import { createBagOperationService, getBagService, sendTicketAbonoService } from "../../../services/client/bagService";
import { useEffect } from "react";
import { setLoading, setTitle } from "../../../redux/slices/uiSlice";
import { setSession } from "../../../redux/slices/sessionSlice";
import moment from "moment";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { currencyFormatter, hideEmail } from "helpers/util";
import { Box, Button, Grid } from "@mui/material";
import DialogModal from "components/modal/DialogModal";
import theme from "config/theme";
import Images from "assets/images";
import Swal from "sweetalert2";

const BagOperationsScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { updateBalance } = useSelector((store) => store.session);
  const { currentCommerce } = useSelector((store) => store.commerces);
  const [dialog, setDialog] = useState({ open: false, title: '', body: '' });

  useEffect(() => {
    dispatch(setTitle('Operación en bolsa'));
    dispatch(setLoading(false));
    // eslint-disable-next-line
  }, [])

  const values = {
    payment: "",
    reference: "",
    type: "",
  };

  const handlerSubmit = async (result, bag) => {
    dispatch(setLoading(true));
    const hashtag = bag.hashtag.replace('(PDS)', '').replace('(TAE)', '') + ` (${bag.type})`;
    createBagOperationService(bag._id, {
      reference: result.reference,
      abono: result.payment,
      tipo_abono: result.type.toUpperCase(),
    }).then((data) => {
      dispatch(setSession({ updateBalance: updateBalance + 1 }));
      if (result.type.toUpperCase() === 'ABONO') {
        const date = moment().format('DD/MM/YYYY HH:mm:ss');
        setDialog({
          open: true,
          title: "Nuevo abono",
          body:
            <div id="abono">
              <div className='container-header-logo'>
                <img alt='logo' className='header-logo' src={Images[theme.code].logo_ticket} />
              </div>
              <h4>Comercio: {currentCommerce.username}</h4>
              <h4>Bolsa: {hashtag}</h4>
              <table width="100%">
                <tbody>
                  <tr>
                    <td style={{ textAlign: 'right' }}>Fecha y Hora:</td>
                    <td>{date}</td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: 'right' }}>Saldo Inicial:</td>
                    <td>{currencyFormatter.format(data.saldo_anterior)}</td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: 'right' }}>Importe Abonado:</td>
                    <td>{currencyFormatter.format(result.payment)}</td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: 'right' }}>Abono de Comisión:</td>
                    <td>{currencyFormatter.format(data.commission)}</td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: 'right' }}>Saldo Final:</td>
                    <td>{currencyFormatter.format(data.saldo_final)}</td>
                  </tr>
                </tbody>
              </table>
            </div>,
          closeText: "Continuar",
          successText: "Descargar",
          onClose: () => {
            navigate(-1);
          },
          onSuccess: () => {
            document.body.appendChild(document.createElement('div')).innerHTML = `
            <div id="ticket-print"  >
              <img alt='logo'  src='${Images[theme.code].logo_ticket}' width="200" style="margin-bottom: 30px;" />
              <h5>Comercio: ${currentCommerce.username}</h5>
              <h5 style="margin-bottom: 30px;">Bolsa: ${hashtag}</h5>
              <table width="100%">
                <tr>
                  <td style="text-align: right">Fecha y Hora:</td>
                  <td>${moment().format('DD/MM/YYYY HH:mm:ss')}</td>
                </tr>
                <tr>
                  <td style="text-align: right">Saldo Inicial:</td>
                  <td>${currencyFormatter.format(data.saldo_anterior)}</td>
                </tr>
                <tr>
                  <td style="text-align: right">Importe Abonado:</td>
                  <td>${currencyFormatter.format(result.payment)}</td>
                </tr>
                <tr>
                  <td style="text-align: right">Abono de Comisión:</td>
                  <td>${currencyFormatter.format(data.commission)}</td>
                </tr>
                <tr>
                  <td style="text-align: right">Saldo Final:</td>
                  <td>${currencyFormatter.format(data.saldo_final)}</td>
                </tr>
              </table>
            </div>`;
            html2canvas(document.querySelector('#ticket-print')).then(
              canvas => {
                const imgData = canvas.toDataURL('image/png');
                const pdf = new jsPDF({
                  format: [80, 100],
                  unit: "mm"
                });
                pdf.addImage(imgData, 'PNG', 10, 20, 60, 60);
                pdf.save('comprobante.pdf');
                document.querySelector('#ticket-print').remove();
              }
            );
          },
          additionalButton: (
            <Button 
              color='info'
              onClick={() => {
                setDialog({ open: false })
                Swal.fire({
                  title: 'Ingresa el correo electrónico',
                  input: 'text',
                  inputAttributes: {
                    autocapitalize: 'off'
                  },
                  showCancelButton: true,
                  confirmButtonText: 'Enviar',
                  showLoaderOnConfirm: true,
                  cancelButtonColor: "#ED3726",
                  preConfirm: (email) => {
                    return sendTicketAbonoService(bag._id, email, {
                      bag: hashtag,
                      commerce: currentCommerce.username,
                      date: date,
                      saldo_anterior: data.saldo_anterior,
                      abono: result.payment,
                      commission: data.commission,
                    }).then(() => {
                      confirmAlert({
                        icon: "success",
                        title: "Enviado",
                        text: `Se ha enviado el comprobante del abono al correo electrónico ${hideEmail(email)}`,
                        showCancelButton: false,
                      })
                    }).catch((error) => {
                      Swal.showValidationMessage(error)
                    })
                  },
                  allowOutsideClick: () => !Swal.isLoading()
                })
              }}
              variant="contained"
            >
              Enviar
            </Button>
          )
        })
      }
    }).catch((e) => errorAlert(e))
      .finally(() => dispatch(setLoading(false)));
  };

  return (
    <Box mt={2} textAlign={'center'}>
      <BackButton click={() => navigate(-1)} />
      <Grid container direction="row" justifyContent="center" alignItems="center" mb={4}>
        <div className='container-title'>
          <div className='commerce'>Comercio: {currentCommerce?.username} </div>
        </div>
      </Grid>
      <Box>
        {
          currentCommerce.bags.map((bag, index) => (
            <BagOperationForm
              key={index}
              title={`Operación en bolsa ${bag.type}`}
              bag={bag}
              submit={handlerSubmit}
              values={values}
            />
          ))
        }
      </Box>
      <DialogModal {...dialog} />
    </Box>
  );
};

export default BagOperationsScreen;
